import React from "react";
import {
    Box,
    Typography,
    Grid,
    Divider,
    Tooltip
} from "@mui/material";
import Card from "../../../components/ui/Card";
import { formatDate } from "../../../utils/dateFormatUtils";
import { formatIndianRupees } from "../../../utils/formatting";
import ClickableTooltip from "./ClickableTooltip";
import InfoIcon from "../../../assets/images/icons/info.png";

interface Column {
    field: string;
    headerName: string;
    width?: number;
    type?: string;
}

const getStatusColor = (status: string) => {
    switch (status?.toLowerCase()) {
        case 'approve':
        case 'success':
            return "#28c76f"; // green
        case 'reject':
        case 'failed':
            return "red"; // red
        case 'pending':
            return "#eaa45eff"; // orange
        case 'in progress': // typo support
            return "#6a6adb"; // blue    
        case 'LINK_EXPIRED': // typo support
            return "#6c757d"; // grey
        default:
            return undefined;
    }
};

const getColumnValue = (item: any, column: Column) => {
    const value = item[column.field];
    if (column.field === 'transcationReferenceNo' && value && typeof value === 'string' && value.length > 8) {
        return (
            <ClickableTooltip title={value}>
                <span>{`${value.substring(0, 8)}...`}</span>
            </ClickableTooltip>
        );
    }

    if (column.type === 'date' || column.field === 'created_at') {
        return formatDate(value);
    }

    if (column.type === 'amount') {
        return Number(value);
    }
    if (column.field === 'status') {
        if(value === 'pending'){
            return "Pending"
        }else if(value === 'approve'){
            return "Approved"
        }
        else if(value === 'reject'){
            return (
                <span>{"Rejected"} 
                    <Tooltip
                        title={item?.remark}
                        enterTouchDelay={50}
                        placement="top"
                    >
                    <img
                        src={InfoIcon}
                        alt="Status"
                        style={{
                        height: "15px",
                        width: "15px",
                        bottom: "-3px",
                        position: "relative",
                        left: "6%",
                        }}
                    />
                    </Tooltip>
                </span>
            )
        }
        else{
            return value;
        }
    }
    if(column.field === 'newStatus'){
        if(value === 'Failed'){
            if(item["status"] === 'LINK_EXPIRED'){
                return "Link Expired"
            }else if(item["status"] === 'PAYMENT_FAILED'){
                return "Failed"
            }
        }
    }

    return value;
}

const ItemCard = ({ item, columns }: { item: any; columns: Column[] }) => (
    <Box mb={4}>
        <Card>
            <Grid
                container
                className="dashboard-container-mobile"
                spacing={1}
                style={{ marginBottom: "5px", marginTop: "0.1px" }}
            >
                {columns.slice(0, 2).map((column) => (
                    <Grid item xs={6} sm={6} key={column.field}>
                        <Typography className="insidePageLableMobile">
                            {column.headerName}
                        </Typography>
                        <Typography className="insidePageValueCardItemMobile" style={{ marginTop: "5px" }}>
                            {getColumnValue(item, column)}
                        </Typography>
                    </Grid>
                ))}
            </Grid>
            {columns.length > 2 && (
                <>
                    <Divider sx={{ paddingBottom: "5px", paddingTop: "2px" }} />
                    <Grid
                        container
                        className="dashboard-container-mobile"
                        spacing={1}
                        style={{ marginBottom: "2px", marginTop: "2px" }}
                    >
                        {columns.slice(2).map((column) => (
                            <Grid
                                item
                                xs={12 / Math.min(3, columns.slice(2).length)}
                                sm={12 / Math.min(3, columns.slice(2).length)}
                                key={column.field}
                                style={{ marginBottom: "10px" }}
                            >
                                <Typography className={`insidePageLableMobile`}>
                                    {column.headerName} 
                                </Typography>
                                <Typography
                                    className="insidePageValueCardItemMobile"
                                    style={
                                        column.field === 'status' || column.field === 'newStatus'
                                            ? { color: getStatusColor(item[column.field]) }
                                            : column.field === 'transactionType'
                                                ? { color: item[column.field] === 'CREDIT' ? "#28c76f" : "#EA5455" }
                                                : undefined
                                    }
                                    sx={{ marginTop: "5px" }}
                                >
                                    {getColumnValue(item, column)}
                                </Typography>
                            </Grid>
                        ))}
                    </Grid>
                </>
            )}
        </Card>
    </Box>
);

const CardItemListFlexi = ({ columns, rows }: { columns: Column[], rows: any[] }) => {
    return (
        <div>
            {rows.length === 0 ? (
                <Typography variant="h6" align="center" className="no-records-found">
                    No records found
                </Typography>
            ) : (
                rows.map((item, index) => (
                    <ItemCard
                        key={item.transactionId || index}
                        item={item}
                        columns={columns}
                    />
                ))
            )}
        </div>
    );
};

export default CardItemListFlexi; 